import React, { useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'

import DisplayCourseMaterial from '../Components/CourseForParticipants/DisplayCourseMaterial/DisplayCourseMaterial'
import Exam from '../Components/CourseForParticipants/Exam/Exam'
import { ParticipantCourseContext } from '../Components/CourseForParticipants/Context/ParticipantCourseContext'
import NotFound from './PageNotFound'

type CourseForParticipantsProps = {
  examLink: string | undefined
}

const CourseForParticipants: React.FC<CourseForParticipantsProps> = () => {
  const link = useParams().examLink

  const {
    invalidLinkError,
    accessExam,
    isExamStarted,
    allQuestionsAnswered,
    setOriginalLinkForParticipants
  } = useContext(ParticipantCourseContext)
  
  useEffect(() => {
    if (link) {
      accessExam(link)
      setOriginalLinkForParticipants(link)
    }
  }, [ link ])



  if (invalidLinkError) {
    return (
      <NotFound />
    )
  }

  return (
    <>
      <DisplayCourseMaterial />

      {isExamStarted && !allQuestionsAnswered && (
        <Exam />
      )}
    </>
  )
}

export default CourseForParticipants